import * as React from "react";
import ProductDetails, { IProductDetailsProps } from "../product-details/product-details";
import { WorkVariantProps } from "./work-variant-form/work-variant-form";

export interface WorkDetailsProps {
    productIndex: number;
    work: {
        products: IProductDetailsProps[];
    };
}

const replaceUrlProductId = (productId: string) => {
    if (typeof window === undefined) {
        return;
    }

    const { origin, pathname, search } = window.location;

    const newPathname = pathname.replace(/[0-9]{13}/g, productId);

    window.history.replaceState({}, "", `${origin}${newPathname}${search}`);
};

const WorkDetails: React.FC<WorkDetailsProps> = ({ work, productIndex }) => {
    const [currentProduct, setCurrentProduct] = React.useState<IProductDetailsProps>({
        ...work.products[productIndex || 0]
    });

    const onVariantSelect: WorkVariantProps["onVariantSelect"] = selectedProductIndex => {
        const selectedProduct = { ...work.products[Number(selectedProductIndex)] };
        const productId = selectedProduct.product.productId;

        replaceUrlProductId(productId);
        setCurrentProduct(selectedProduct);
    };

    return (
        <ProductDetails
            {...currentProduct}
            className="work-details"
            onVariantSelect={onVariantSelect}
            variants={work.products}
            initialVariantIndex={productIndex}
        />
    );
};

export default WorkDetails;
